import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const StyledDiv = styledComponent('div', {
  display: 'flex',
  gap: theme.spacing.gapXl,
  flexWrap: 'wrap',

  '& .tab-btn': {
    padding: theme.spacing.smallButtonPadding,
    minWidth: theme.sizes.tabMinWidth,
    background: theme.colors.bgCard,
    color: theme.colors.text,
    border: theme.borders.input,
    borderRadius: theme.radii.input,
    ...theme.typography.button,
    cursor: 'pointer',
    transition: theme.transitions.default,
  },

  '& .tab-btn:hover:not([aria-selected="true"])': {
    borderColor: theme.colors.infoBlue,
  },

  '& .tab-btn:focus': {
    outline: 'none',
    boxShadow: `0 0 0 2px ${theme.colors.infoBlue}33`,
    borderColor: theme.colors.infoBlue,
  },

  '& .tab-btn[aria-selected="true"]': {
    background: theme.colors.primary,
    color: theme.colors.white,
    borderColor: theme.colors.primary,
  },

  [`@media (max-width: ${theme.breakpoints.mobile})`]: {
    flexWrap: 'nowrap',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: theme.spacing.gapSm,
    '& .tab-btn': {
      flexShrink: 0,
    },
  },
});

function Tabs({ tabs, activeId, onChange }) {
  return (
    <StyledDiv role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          className="tab-btn"
          aria-selected={tab.id === activeId}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </StyledDiv>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
